// extracted by mini-css-extract-plugin
export default {"checkoutAward":"styles_checkoutAward__9gUkJ","content":"styles_content__A4f5A"};